import Vue from 'vue'
 import App from './App.vue'
 import router from './router'
 import store from './store'
 import ElementUI from 'element-ui';
 import 'element-ui/lib/theme-chalk/index.css';
 import axios from 'axios';
 Vue.prototype.$axios = axios
 Vue.use(ElementUI);
 Vue.config.productionTip = false

 // axios.defaults.baseURL = '/api' //关键代码
 axios.defaults.baseURL = process.env.NODE_ENV === 'development' ? '/api' : 'http://www.xiaozhaozhushou.net'
 Vue.config.productionTip = false;

 Vue.prototype.timeFilter = function(val, bo) {
 	if (bo) return `${val.substr(5,2)}月${val.substr(8,2)}日`
 	return `${val.substr(0,4)}年${val.substr(5,2)}月${val.substr(8,2)}日`
 	// return 
 }

	setInterval(() => {
		if(window.localStorage.getItem('token')){
			axios.get(`/api/user/getUserByToken?api_token=${window.localStorage.getItem('token')}`)
				.then((res) => {
					console.log(res)
				}).catch((err) =>{
					if(err.response.status == 401){
						alert('登陆状态已过期');
						store.commit('ISLOGIN', false);
						store.commit('ISVIP', false);
						window.localStorage.clear();
					}
				});
		}
	},1000 * 10)

 router.beforeEach((to, from, next) => {
 	if (to.meta.title) {
 		document.title = to.meta.title
 	}
 	next()
 })

 new Vue({
 	router,
 	store,
 	render: h => h(App)
 }).$mount('#app')
